'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExperimentsProvider = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.withExperiments = withExperiments;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _wixExperiments = require('wix-experiments');

var _wixExperiments2 = _interopRequireDefault(_wixExperiments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperimentsProvider = exports.ExperimentsProvider = function (_Component) {
  (0, _inherits3.default)(ExperimentsProvider, _Component);

  function ExperimentsProvider(props, context) {
    (0, _classCallCheck3.default)(this, ExperimentsProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExperimentsProvider.__proto__ || (0, _getPrototypeOf2.default)(ExperimentsProvider)).call(this, props, context));

    _this.experiments = new _wixExperiments2.default(props.options);
    return _this;
  }

  (0, _createClass3.default)(ExperimentsProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { experiments: this.experiments };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);
  return ExperimentsProvider;
}(_react.Component);

ExperimentsProvider.propTypes = {
  options: _react.PropTypes.object.isRequired,
  children: _react.PropTypes.element.isRequired
};

ExperimentsProvider.childContextTypes = {
  experiments: _react.PropTypes.object.isRequired
};

function withExperiments(WrappedComponent) {
  var ExperimentsWrapper = function (_Component2) {
    (0, _inherits3.default)(ExperimentsWrapper, _Component2);

    function ExperimentsWrapper(props, context) {
      (0, _classCallCheck3.default)(this, ExperimentsWrapper);

      var _this2 = (0, _possibleConstructorReturn3.default)(this, (ExperimentsWrapper.__proto__ || (0, _getPrototypeOf2.default)(ExperimentsWrapper)).call(this, props, context));

      _this2.experiments = context.experiments;
      _this2.state = { ready: !_this2.experiments.pending() };
      _this2.experiments.ready().then(function () {
        return _this2.setState({ ready: true });
      });
      return _this2;
    }

    (0, _createClass3.default)(ExperimentsWrapper, [{
      key: 'render',
      value: function render() {
        var extraProps = { experiments: this.experiments };
        if (this.state.ready) {
          return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, extraProps));
        } else {
          return null;
        }
      }
    }]);
    return ExperimentsWrapper;
  }(_react.Component);

  ExperimentsWrapper.WrappedComponent = WrappedComponent;

  ExperimentsWrapper.contextTypes = {
    experiments: _react.PropTypes.object
  };

  return ExperimentsWrapper;
}
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-experiments-react/dist/src/index.js
// module id = 35
// module chunks = 0